<template>
  <div>
    <el-card class="box-card">
      <div style="overflow: hidden;">
        <ul class="list-left">
          <div style="width: 100%;padding: 10px 0;background: #ebebeb;position : sticky;top:0;z-index: 100;">
            <div style="width: 100%;overflow: hidden;">
              <div style="width: 76%;float: left;margin-left:2%;">
                <el-input clearable size="mini" :placeholder="$t('message.placeholder.input')" @clear="searchLists"
                  @keyup.enter.native="searchLists" v-model="search" class="input-with-select"
                  style="margin:0 20px 0 0">
                  <el-button slot="append" icon="el-icon-search" @click="searchLists"></el-button>
                </el-input>
              </div>
              <div style="float: left;margin-left:2%;">
                <el-button type="success" size="mini" icon="el-icon-circle-plus-outline"
                  @click="addNewAutoNum"></el-button>
              </div>
            </div>
          </div>
          <li v-for="(item, index) in gridOptions.data" :key="item.id" :title="item.name"
            :class="{ isDisable: item.enabled == 0, active: index == num }">
            <span class="list-left-label" @click="dbClick(item, index)">
              {{ item.name }}
            </span>
            <span style="position: relative;top: -5px;">
              <el-switch v-model="listEnabled[index].value" active-color="#13ce66"
                @change="changeAutoNumberStatus(item)">
              </el-switch>
              <el-button :title="$t('message.button.delete')" type="text" style="color: black;margin-left: 12px;"
                @click="removeRowEvent(item)" icon="el-icon-delete"></el-button>
            </span>
          </li>
        </ul>

        <div class="list-right">
          <Tab :atuoNumberName="atuoNumberName" @click="tabClick" />
          <section>
            <transition name="fade-transform" mode="out-in">
              <router-view :key="key" @update="getUp"></router-view>
            </transition>
          </section>
        </div>

      </div>
    </el-card>

    <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" class="autoNum-edit" title="添加自动编号"
      :visible.sync="pageListDataShow" @closed="dialogClose">
      <el-form ref="ruleForm" :model="autoNumber_edit" style="margin:20px 40px;" label-width="120px" size="small"
        :rules="rules">
        <el-form-item :label="$t('message.table.name')" prop="name">
          <el-input v-model="autoNumber_edit.name" :style="input_width"></el-input>
        </el-form-item>

        <el-form-item :label="$t('message.table.startNumber')" prop="beginNumber">
          <el-input v-model="autoNumber_edit.beginNumber" :style="input_width" :disabled='!addAutoNum'
            @input="filterBeginNumber"></el-input>
        </el-form-item>

        <el-form-item :label="$t('message.table.numberLength')" prop="numberLength">
          <el-input v-model="autoNumber_edit.numberLength" :style="input_width" @blur="filterNumberLength"></el-input>
        </el-form-item>

        <el-form-item :label="$t('message.table.des')">
          <el-input class="desc" type="textarea" maxlength="500" show-word-limit
            v-model="autoNumber_edit.description"></el-input>
        </el-form-item>

        <el-form-item :label="$t('message.table.isEnabled')">
          <el-select v-model="autoNumber_edit.enabled" :placeholder="$t('message.placeholder.select')" size="small"
            style="width:100%">
            <el-option :label="$t('message.table.yes')" value="1"></el-option>
            <el-option :label="$t('message.table.no')" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('message.table.prefix')">
          <el-input v-model="autoNumber_edit.pre" :style="input_width"></el-input>
        </el-form-item>

        <el-form-item :label="$t('message.table.suffix')">
          <el-input v-model="autoNumber_edit.suf" :style="input_width"></el-input>
        </el-form-item>

        <el-form-item :label="$t('message.table.nextAutoNumber')">
          <el-input v-model="autoNumber_edit.nextAutoNumber" :style="input_width" disabled></el-input>
        </el-form-item>
      </el-form>
      <div style="height: 30px;">
        <el-button v-if="addBtn_Show" size="mini" type="success" style="float: left;margin-left: 25%;"
          @click="saveNewAutoNum('ruleForm')">{{ $t('message.button.add') }}</el-button>
        <div id="reset_btn">
          <el-button size="mini" style="float: left;margin-left: 25%;" @click="closePageInfo">{{
            $t('message.button.reset') }}</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import axios from "axios";
import Tab from "./components/Tab.vue";
export default {
  data() {
    return {
      num: -1,
      listEnabled: [],
      input_width: { width: "50%" },
      search: "",
      basicData: [],
      listNames: [],
      createForm: {
        name: "",
        listType: "1",
        description: "",
        enabled: "1",
        codeValueLength: "",
      },
      addShow: false,
      form: {
        name: "",
      },
      gridOptions: {
        keepSource: true,
        resizable: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "700",
        columns: [],
        data: [],
        editConfig: {
          mode: "row",
          showIcon: false,
          showStatus: true,
        },
        sortConfig: {
          trigger: "cell",
        },
      },
      userInfo: [],

      pageListDataShow: false,
      autoNumber_edit: [],
      rules: {
        name: [
          { required: true, message: this.$t('message.warning.required'), trigger: 'blur' },
        ],
        beginNumber: [
          { required: true, message: this.$t('message.warning.required'), trigger: 'blur' }
        ],
        numberLength: [
          { required: true, message: this.$t('message.warning.required'), trigger: 'blur' },
        ],
      },
      addAutoNum: false,
      addBtn_Show: false,
      currentRow: {},  //记录当前选中的数据，用于删除后再次选中
      currentIndex: 0,
      atuoNumberName: ''
    };
  },
  mounted() { },
  components: { Tab },
  computed: {
    key() {
      const { id } = this.$route.query;
      return id
    }
  },
  created() {
    this.getAutoNumbersList();
  },
  methods: {
    getUp() {
      this.getAutoNumbersList()
    },
    dbClick(row, index) {
      console.log(row);

      this.currentRow = row;
      this.currentIndex = index;
      this.atuoNumberName = row.name;

      this.userInfo = row;
      this.num = index;
      this.$store.commit("setListId", row.id);

      const ObjectId = {
        id: row.id
      };
      this.$store.commit('setObjectId', ObjectId);
      this.$store.commit('setShowUserName', row.name);

      const e = '/autoNumbers/AutoNumbersInfo';
      let obj = {
        path: e,
        query: ObjectId
      };
      this.$router.push(obj);
    },
    //搜索
    searchLists() {
      if (!this.search) {
        this.gridOptions.data = this.basicData;
        this.listEnabled = this.basicData.map((item, index) => ({
          value: item.enabled,
          editable: item.enabled
        }));
        return;
      }
      const searchTerm = this.search.toLowerCase();
      const searchVal = this.basicData.filter(item =>
        item.name.toLowerCase().includes(searchTerm)
      );
      this.gridOptions.data = searchVal;
      this.listEnabled = searchVal.map((item, index) => ({
        value: item.enabled,
        editable: item.enabled
      }));
    },
    //变更自动编号的状态
    async changeAutoNumberStatus(row) {
      try {
        const updatedStatus = row.enabled === false ? 1 : 0;
        const updateObject = {
          enabled: updatedStatus,
          id: row.id
        };
        const response = await axios.post('/pmdm/admin/autonumber/update', updateObject);
        if (response.data && response.data.code === 200) {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'success'
          });
          // 如果需要在成功后刷新列表，可以调用此方法  
          // this.getAutoNumbersList();  
        } else {
          this.getAutoNumbersList();
        }
      } catch (error) {
        console.error('请求失败:', error.message || '网络请求出错');
        this.$message({
          showClose: true,
          message: '更新自动编号状态时出错',
          type: 'error'
        });
      }
    },
    //获取全部自动编号
    async getAutoNumbersList() {
      this.input_width = this.Global.input_width_small;
      try {
        const response = await axios.get("/pmdm/admin/autonumber/getAutoNumbers");
        const autoNumbersData = response.data.object.autoNumbers;
        const processAutoNumberItem = (item) => ({
          beginNumber: item.beginNumber,
          description: item.description,
          enabled: item.enabled !== 0,
          id: item.id,
          name: item.name,
          nextAutoNumber: item.nextAutoNumber,
          nextNumber: item.nextNumber,
          numberLength: item.numberLength,
          pre: item.pre,
          suf: item.suf,
          editable: item.enabled !== 0
        });
        this.gridOptions.data = autoNumbersData.map(processAutoNumberItem);
        this.basicData = this.gridOptions.data;
        this.listNames = autoNumbersData.map(item => item.name);
        this.listEnabled = autoNumbersData.map(item => ({ value: item.enabled !== 0, editable: item.enabled !== 0 }));

        const { data } = this.gridOptions;

        if (this.currentIndex != null) {

          const targetIndex = this.currentIndex >= data.length ? 0 : this.currentIndex;
          const targetRow = targetIndex === 0 ? data[0] : this.currentRow;

          this.dbClick(targetRow, targetIndex);
        }
      } catch (error) {
        console.error("Error fetching auto number data:", error);
      }
    },
    tabClick(e) {
      let query = this.$route.query;
      const { path } = e;
      this.$router.push({ path, query });
    },
    //关闭添加自动编号窗口
    dialogClose() {
      this.addAutoNum = false;
      this.$refs.ruleForm.resetFields()
    },
    //添加新的自动编号
    addNewAutoNum() {
      this.addAutoNum = true;
      this.pageListDataShow = true;
      this.addBtn_Show = true;
      this.autoNumber_edit = {};
      this.autoNumber_edit_old = {};
    },
    //提交新建自动编号的表单
    saveNewAutoNum(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return false;
        }
        const obj = this.autoNumber_edit;
        if (obj.beginNumber.length > obj.numberLength) {
          this.$message.error(this.$t('message.error.autoNumLength'));
          return false;
        }
        axios.post('/pmdm/admin/autonumber/save', obj).then(res => {
          if (res.data.code === 200) {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'success'
            });
            this.pageListDataShow = false;
            this.getAutoNumbersList();
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'success'
            });
          }
        }).catch(error => {
          this.$message.error('Failed to save auto number.');
        });
      });
    },
    //删除自动编号
    removeRowEvent(item) {
      if (item.id === 500) {
        this.$message({
          type: 'error',
          message: this.$t('message.error.noEdit')
        });
        return false;
      }
      this.$confirm(
        this.$t('message.confirm.deleteList'),
        this.$t('message.tips.tip'),
        {
          confirmButtonText: this.$t('message.button.affirm'),
          cancelButtonText: this.$t('message.button.cancel'),
          type: 'warning'
        }
      ).then(() => {
        axios.post(`/pmdm/admin/autonumber/delete?id=${item.id}`).then(res => {
          if (res.data.code === 200) {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'success'
            });
            const e = '/autoNumbers';
            let obj = {
              path: e,
              query: ""
            };
            // this.$router.push(obj);
            this.getAutoNumbersList();
          } else {
            // this.$message({ type: 'error', message: this.$t('message.error.unknown') });
          }
        }).catch(error => {
          console.error('Error deleting item:', error);
          this.$message({
            showClose: true,
            type: 'error',
            message: this.$t('message.error.network')
          });
        });
      }).catch(() => {
        this.$message({
          showClose: true,
          type: 'info',
          message: this.$t('message.tips.deleteCancel')
        });
      });
    },
    filterBeginNumber() {
      this.autoNumber_edit.beginNumber = this.autoNumber_edit.beginNumber.replace(/[^0-9]/g, '');
    },
    filterNumberLength(e) {
      let n = parseInt(this.autoNumber_edit.numberLength)
      let arr = (this.autoNumber_edit.beginNumber + '').split('');
      this.autoNumber_edit.numberLength = n < arr.length || isNaN(n) ? arr.length : n;
    },
    closePageInfo() {
      if (this.addAutoNum) {
        this.autoNumber_edit = {};
      } else {
        this.autoNumber_edit.name = "";
        this.autoNumber_edit.numberLength = "";
        this.autoNumber_edit.description = "";
        this.autoNumber_edit.enabled = "";
        this.autoNumber_edit.pre = "";
        this.autoNumber_edit.suf = "";
      }
    },
  }

};
</script>

<style scoped>
.demo-ruleForm {
  width: 60%;
}

.add_form {
  padding: 15px 0;
  background: #fff;
}

.list-right {
  width: 72%;
  height: 740px;
  overflow: auto;
  padding: 0;
  float: left;
  border: 2px solid #ebebeb;
  margin: 0 0 0 16px;
}

.list-left {
  width: 25%;
  height: 740px;
  overflow: auto;
  padding: 0;
  border: 2px solid #ebebeb;
  float: left;
  position: relative;
  margin: 0;
}

.list-left li {
  padding: 4px;
  height: 20px;
}

.list-left li:hover {
  background: #5cb0f8;
  color: #fff;
}

.list-left-label {
  display: inline-block;
  width: 72%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  cursor: pointer;
}

.isDisable {
  color: rgb(255, 11, 0);
}

.active {
  background: #5cb0f9;
  color: #fff;
}
</style>